module.exports = __webpack_public_path__ + "img/feature_buy_th.f7df08ae.png";